import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import styles from './AppLayout.module.css';
import { useAuth } from '../../store/AuthContext';
import NotificationBell from '../../components/NotificationBell';
import { classNames } from '../../utils/helpers';
import {
  DashboardIcon,
  SubscriptionIcon,
  PaymentIcon,
  TransactionIcon,
  ProfileIcon,
  LogoutIcon,
  DownloadIcon,
  MenuIcon,
  XIcon,
} from '../../components/Icons';

const navItems = [
  { path: '/dashboard', label: 'Dashboard', icon: DashboardIcon },
  { path: '/subscription', label: 'Subscription', icon: SubscriptionIcon },
  { path: '/plans', label: 'Plans', icon: PaymentIcon },
  { path: '/payment-history', label: 'Payment History', icon: TransactionIcon },
  { path: '/profile', label: 'Profile', icon: ProfileIcon },
  { path: '/download', label: 'Download EXE', icon: DownloadIcon },
];

function AppLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className={styles.layout}>
      {/* Mobile overlay */}
      {sidebarOpen && (
        <div className={styles.overlay} onClick={() => setSidebarOpen(false)} />
      )}

      {/* Sidebar */}
      <aside className={classNames(styles.sidebar, sidebarOpen && styles.sidebarOpen)}>
        <div className={styles.sidebarHeader}>
          <div className={styles.logo}>
            <img src="/image_1_3.png" alt="DSC Platform" className={styles.logoIcon} />
          </div>
          <button className={styles.closeSidebar} onClick={() => setSidebarOpen(false)}>
            <XIcon />
          </button>
        </div>

        <nav className={styles.nav}>
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                classNames(styles.navItem, isActive && styles.navItemActive)
              }
              onClick={() => setSidebarOpen(false)}
            >
              <item.icon className={styles.navIcon} />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className={styles.sidebarFooter}>
          <button className={styles.logoutButton} onClick={handleLogout}>
            <LogoutIcon className={styles.navIcon} />
            <span>Logout</span>
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <div className={styles.main}>
        {/* Header */}
        <header className={styles.header}>
          <button className={styles.menuButton} onClick={() => setSidebarOpen(true)}>
            <MenuIcon />
          </button>
          <div className={styles.headerContent}>
            <div className={styles.headerRight}>
              <NotificationBell />
              <div className={styles.userInfo}>
                <div className={styles.avatar}>
                  {user?.name?.charAt(0).toUpperCase() || 'U'}
                </div>
                <div className={styles.userDetails}>
                  <span className={styles.userName}>{user?.name || 'User'}</span>
                  <span className={styles.userEmail}>{user?.email || ''}</span>
                </div>
              </div>
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className={styles.content}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default AppLayout;
